import { createFileRoute } from "@tanstack/react-router";
import { CreateRaid } from "@/raids/CreateRaid.tsx";

export const Route = createFileRoute("/raids_/create")({
  component: () => <CreateRaid />,
});
